var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.children.length
    ? _c(
        "ul",
        _vm._l(_vm.content.children, function (obj, index) {
          return _c("li", { staticClass: "flex-box" }, [
            _c("span", { staticClass: "forth-index" }, [
              _vm._v("." + _vm._s(index + 1)),
            ]),
            _vm._v("\n    " + _vm._s(obj.header[0].content) + "\n  "),
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }